import React from 'react';

import { ItemType } from 'Shared/constants/types';

import './WorkspaceItemParentInfo.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  workspacePath: string;
  parentText: string;
  parentUuid: string;
  itemType: ItemType;
};

function WorkspaceItemParentInfo({ workspacePath, itemType, parentText, parentUuid }: Props) {
  const { tr } = useTranslation();
  const parentItemWorkspacePath = `${workspacePath}/item/${parentUuid}`;
  const relationLabel =
    itemType === ItemType.actionItem
      ? tr('perform.workspace.parent_info.sub_item_of')
      : tr('perform.workspace.parent_info.sub_topic_of');
  return (
    <div className="your-action-item-parent-info pb-1">
      <span className="mr-2">{relationLabel}</span>
      <a href={parentItemWorkspacePath} target="_blank" rel="noopener noreferrer">
        {parentText || tr('perform.workspace.parent_info.empty_item')}
      </a>
    </div>
  );
}

export default WorkspaceItemParentInfo;
